import { useQuery } from '@tanstack/react-query';
import stationApiRequestService from '../../service/stationApiRequests/apiService';
import { useAuth } from '../../component/context/AuthContext/AuthContext';

const getLaserStationsEndpoint = '/jetstream/api/1/getlaserstations';

const useStationApi = (_queryParams: string, printerType: string) => {
  const { userData } = useAuth();
  const url = getLaserStationsEndpoint;

  return useQuery({
    queryKey: [url, printerType, userData?.access_token],
    queryFn: () =>
      stationApiRequestService(url, printerType, userData?.access_token),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: 3,
  });
};

export default useStationApi;
